import React from 'react'
import { Card, CardContent } from '@mui/material'
import { ClassNameMap } from '@mui/styles'
import MedicationsComponent from '../common/medications.component'
import { useCurrentUser } from '../../../../utils/use-current-user'
import { PatientService } from '../../../../services/patient.service'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { toast } from 'react-toastify'
import Helper from '../../../../utils/helper'
import { useUpdateDataAction } from '../../../../utils/update-details-hook'

interface IAddNewMedicationCardProps {
  classes: ClassNameMap
  patientId: string
  isMedReconcile?: boolean
  currentStage: string
  uiResource: any
  handleClose: () => void
  handleSubmit: any
}

const AddNewMedicationCard: React.FC<IAddNewMedicationCardProps> = ({
  classes,
  patientId,
  isMedReconcile,
  currentStage,
  uiResource,
  handleClose,
  handleSubmit,
}) => {
  const patientDetail = useSelector((state: RootState) => state.patientDetail.patientDetail)
  const { currentRole } = useCurrentUser()
  const patientService = new PatientService()
  const { updatePatientData } = useUpdateDataAction(patientDetail.id)

  const getIntakeReg = (reg: string) => {
    return Object.keys(uiResource.INTAKE_REGULARITIES || {}).find((key: any) => uiResource.INTAKE_REGULARITIES[key] === reg)
  }

  const confirmMedicine = (
    _typeOut: any,
    medicinedata: any,
    _mode: any,
    action?: string
  ) => {
    if (_typeOut === 'confirm') {
      const payload = {
        entity_ref: 'medication',
        entity_id: medicinedata.id,
        confirmed_by: patientDetail.id,
      }
      patientService
        .PostConfirmations(payload)
        .then((_response: any) => {
          updatePatientData({ isMeasurement: true, isTreatments: true, isConditions: false })
        })
        .catch((err: any) => {
          updatePatientData({ isMeasurement: true, isTreatments: true, isConditions: false })
          toast.error(Helper.getErrorText(err), Helper.bottom_center())
        })
    }
  }

  const handleMedSubmit = (values: any, medicine: any, dosageInfo: any, intake: string, _type: string, _mode: string) => {
    let req = {
      med_id: medicine.id,
      med_type: medicine.med_type,
      name: medicine.name,
      num_units: values.num_units,
      delivery_method: values.delivery_method,
      intake_quantity: values.intake_quantity,
      frequency: values.frequency,
      dosage_info: dosageInfo,
      notes: values.note,
      user_role: currentRole,
      prescription_taken: values.prescription_taken,
      intake_regularity: getIntakeReg(intake),
      current_dose_start_date: values.current_dose_start_date || null
    }
    patientService.postOtherMedication(patientDetail.id, req).then((response: any) => {
      (_type === 'confirm')
        ? confirmMedicine(_type, response.data, 'view', 'add')
        : response?.data && (
          isMedReconcile
            ? updatePatientData({ isMeasurement: true, isTreatments: true, isConditions: false })
            : handleSubmit({ ...response.data, mode: _mode })

        )
    }).catch((error: any) => toast.error(Helper.getErrorText(error), Helper.bottom_center()))
  }

  return (
    <Card
      variant='outlined'
      className={[classes.questionCardContent, classes.medIntoleranceCard2].join(' ')}
    >
      <CardContent className={classes.zeroPadding}>
        <MedicationsComponent
          classes={classes}
          writeMode={true}
          noDropDown=""
          heading="Add new medication"
          differently={false}
          input=""
          outer=""
          outerSubmit={handleMedSubmit}
          patientId={patientId}
          currentStage={currentStage}
          medicineInfo={null}
          uiResource={uiResource}
          handleClose={handleClose}
        />
      </CardContent>
    </Card>
  )
}

export default AddNewMedicationCard